import React from 'react';
import { Trans } from '@lingui/macro';
import styles from './style.css';

function LanguageOption(props) {
  const { label, value, isSelected } = props;

  return (
    <div className="col-xs-12">
      <div>
        <label className={styles.languageOptionLabel}>
          <input
            type="radio"
            name="selected-language"
            value={value}
            checked={isSelected}
          />
          &nbsp;
          {label}
        </label>
      </div>
      <div className={styles['mk-divider-section-line']} />
    </div>
  );
}

function LanguageDetail(props) {
  const { currentLocaleId, updateLanguage } = props;

  return (
    <div
      className={`row ${styles['pt-25']}`}
      onChange={e => updateLanguage(e.target.value)}
    >
      <div className="col-xs-12">
        <div className={styles['mk-section-header']}>
          <Trans>Language</Trans>
        </div>
      </div>

      <LanguageOption
        label="Bahasa Indonesia"
        value="id"
        isSelected={currentLocaleId === 'id'}
      />
      <LanguageOption
        label="English"
        value="en"
        isSelected={currentLocaleId === 'en'}
      />
    </div>
  );
}

export default LanguageDetail;
